import { DateHelper } from '@getaccept/lib-shared/src/helpers/date.helper';
import type { DateTime } from 'luxon';
import type { Participant } from '../../types';
import type { Task } from '../types/action-plan';
import AvatarHelper from '../../helpers/avatar.helper';

export default class TaskHelper {
  static getDeadline = (date: DateTime) => {
    const todayPlusMinusOne = DateHelper.todayPlusMinusOne(date);
    if (todayPlusMinusOne) {
      return todayPlusMinusOne;
    }
    if (DateHelper.isSameYear(date)) {
      return date.toLocaleString({
        month: 'short',
        day: 'numeric',
      });
    }
    return date.toLocaleString({
      dateStyle: 'medium',
    });
  };

  static getParticipantAvatars = (participants: Participant[], selectedParticipantIds: string[]) =>
    participants
      .filter(participant => selectedParticipantIds.includes(participant.id))
      .map(participant => ({
        name: AvatarHelper.getDisplayName(participant),
        thumbUrl: participant.thumbUrl,
      }));

  static getTaskUpdatePayload = (newTask: Task, oldTask: Task, ownerId: string) => {
    const updatedFields: Partial<Task> = {};

    if (newTask.participantIds.length !== oldTask.participantIds.length) {
      updatedFields.participantIds = newTask.participantIds;
    }

    if (newTask.status !== oldTask.status) {
      updatedFields.status = newTask.status;
      updatedFields.statusUpdatedBy = ownerId;
    }

    for (const key in newTask) {
      if (key !== 'status' && key !== 'participantIds' && newTask[key] !== oldTask[key]) {
        updatedFields[key] = newTask[key];
      }
    }

    return updatedFields;
  };
}
